import * as Yup from 'yup';
import { tKeys } from '../../../../../../translations/keys';
export const validationSchema = (t) => {
    return Yup.object({
        fileTypeName: Yup.string().required(t(tKeys.validation.common.enter_a_title)),
    });
};
